var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ib-dialog",
    {
      attrs: {
        visible: _vm.dialogThankYouVisible,
        width: "490px",
        "show-close": false,
        "empty-header": "",
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c("ib-divider", { staticClass: "mb-4", attrs: { block: "" } }),
              _c("ib-dialog-footer", {
                attrs: {
                  "button-size": "md",
                  "visible-cancel-btn": false,
                  "submit-btn-text": _vm.$t("close"),
                },
                on: { submit: _vm.sendToHome },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("ib-dialog-confirmation-content", {
        attrs: {
          image: require("@/assets/img/illustrations/dialogs/thank-you-thumbs-up.svg"),
          title: _vm.$t("dialogs.thankYou.title"),
          subtitle: !_vm.isLifetime
            ? _vm.$t("thankYouDescription")
            : _vm.$t("thankYouDescriptionLifetime"),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }